export default __webpack_public_path__ + "static/digitclub-8ab7c4616c15112887561dc2cf3b22d7.png";